import React from 'react';
import { Input, Select } from 'antd';
import PropTypes from 'prop-types';
import cn from 'classnames';
import classes from './Style.module.scss';
import { PHONE_CODE_OPTIONS } from './PhoneCodeOptions';

export default function PhoneNumber({ value, onChange, popupClassName, error }) {
  const { code, phone } = value || {};
  const handlePhoneChange = (e) => {
    onChange({ code, phone: e });
  };
  const handleCodeChange = (e) => {
    onChange({ code: e, phone });
  };

  return (
    <Input.Group className={cn(classes.phoneNumber, { [classes.hasError]: !!error })} compact>
      <Select
        style={{ width: '30%' }}
        popupClassName={popupClassName}
        showSearch
        value={code}
        options={PHONE_CODE_OPTIONS}
        bordered={false}
        className={classes.phoneCode}
        defaultValue="+86"
        onChange={handleCodeChange}
        filterOption={(input, option) => {
          if (!input) return true;
          const criteria = [
            option.raw.name,
            option.raw.iso2,
            option.raw.code ? `+${option.raw.code}` : '',
          ]
            .filter((keyword) => !!keyword)
            .map((keyword) => keyword.toLowerCase());
          return criteria.some((keyword) => keyword.includes(input.toLowerCase()));
        }}
      />
      <Input
        style={{ width: '70%' }}
        stringMode
        controls={false}
        value={phone}
        bordered={false}
        className={classes.phone}
        onChange={(e) => {
          handlePhoneChange(e.target.value);
        }}
      />
    </Input.Group>
  );
}
// Add the 'onChange' prop to the PropTypes validation
PhoneNumber.propTypes = {
  value: PropTypes.shape({
    code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  onChange: PropTypes.func.isRequired,
};

PhoneNumber.defaultProps = {
  value: {
    code: '',
    phone: '',
  },
};
